module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "min-height": "150px"
    }
  }, [(_vm.fieldworkRequestLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.fieldworkRequestLoading) ? _c('div', [_c('tabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('tab', {
    attrs: {
      "header": "Request"
    }
  }, [(_vm.project) ? _c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldworkRequestHeader', {
    attrs: {
      "fieldworkRequest": _vm.fieldworkRequest
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "tabRequest"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit1($event)
      }
    }
  }, [(_vm.fieldworkRequestLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('fieldSet', {
    attrs: {
      "disabled": !_vm.canSave
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Lead Agency Project No(s).")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.leadAgencyProjectNumbers),
      expression: "fieldworkRequest.leadAgencyProjectNumbers"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Lead Agency Project No(s)."
    },
    domProps: {
      "value": (_vm.fieldworkRequest.leadAgencyProjectNumbers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "leadAgencyProjectNumbers", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Other Lead No(s).")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.otherLeadNumbers),
      expression: "fieldworkRequest.otherLeadNumbers"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Other Lead No(s)."
    },
    domProps: {
      "value": (_vm.fieldworkRequest.otherLeadNumbers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "otherLeadNumbers", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Field Org. Project No.")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.fieldOrganizationProjectNumber),
      expression: "fieldworkRequest.fieldOrganizationProjectNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fieldOrganizationProjectNumber",
      "placeholder": "Field Org. Project No."
    },
    domProps: {
      "value": (_vm.fieldworkRequest.fieldOrganizationProjectNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "fieldOrganizationProjectNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('tabRequest.fieldOrganizationId')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Field Org.")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.fieldOrganizationId),
      expression: "fieldworkRequest.fieldOrganizationId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fieldOrganizationId",
      "aria-required": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fieldworkRequest, "fieldOrganizationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.onChangeFieldOrganizationId()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.organizationList), function(organization) {
    return _c('option', {
      key: organization.organizationId,
      domProps: {
        "value": organization.organizationId
      }
    }, [_vm._v("\n                                          " + _vm._s(organization.description) + "\n                                      ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tabRequest.fieldOrganizationId')),
      expression: "errors.has('tabRequest.fieldOrganizationId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Field Org. is required")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldworkRequest.fieldOrganizationId != null && _vm.fieldworkRequest.fieldOrganizationId != ''),
      expression: "fieldworkRequest.fieldOrganizationId != null && fieldworkRequest.fieldOrganizationId != ''"
    }],
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('tabRequest.fieldOrganizationPointOfContactId')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Field Org. POC")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.fieldOrganizationPointOfContactId),
      expression: "fieldworkRequest.fieldOrganizationPointOfContactId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fieldOrganizationPointOfContactId",
      "aria-required": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fieldworkRequest, "fieldOrganizationPointOfContactId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.onChangeOrganizationContactId()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.organizationContactList), function(organizationContact) {
    return _c('option', {
      key: organizationContact.organizationContactId,
      domProps: {
        "value": organizationContact.organizationContactId
      }
    }, [_vm._v("\n                                          " + _vm._s(organizationContact.lastName) + " , " + _vm._s(organizationContact.firstName) + "\n                                      ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tabRequest.fieldOrganizationPointOfContactId')),
      expression: "errors.has('tabRequest.fieldOrganizationPointOfContactId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Field Org. POC is required")])])]), _vm._v(" "), (_vm.selectedOrganizationContact != null) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Field Org. Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOrganizationContact.email),
      expression: "selectedOrganizationContact.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Field Org Email"
    },
    domProps: {
      "value": (_vm.selectedOrganizationContact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedOrganizationContact, "email", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasFieldOrgPocOther) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Field Org. POC Other")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.fieldOrganizationPointOfContactOther),
      expression: "fieldworkRequest.fieldOrganizationPointOfContactOther"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Other POC Name"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.fieldOrganizationPointOfContactOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "fieldOrganizationPointOfContactOther", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('tabRequest.agencyId')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Agency (Land Manager)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.fieldworkRequest.agencyId),
      expression: "fieldworkRequest.agencyId",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "agencyId",
      "aria-required": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fieldworkRequest, "agencyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.onChangeAgencyId()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.agencyList), function(agency) {
    return _c('option', {
      key: agency.organizationId,
      domProps: {
        "value": agency.organizationId
      }
    }, [_vm._v("\n                                          " + _vm._s(agency.description) + "\n                                      ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tabRequest.agencyId')),
      expression: "errors.has('tabRequest.agencyId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Agency (Land Manager)")])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": !_vm.canSave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldworkRequest.agencyId != null && _vm.fieldworkRequest.agencyId != ''),
      expression: "fieldworkRequest.agencyId != null && fieldworkRequest.agencyId != ''"
    }],
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('tabRequest.agencyPointOfContactId')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Agency POC")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.agencyPointOfContactId),
      expression: "fieldworkRequest.agencyPointOfContactId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "agencyPointOfContactId",
      "aria-required": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fieldworkRequest, "agencyPointOfContactId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.onChangeAgencyPointOfContactId()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.agencyContactList), function(agencyContact) {
    return _c('option', {
      key: agencyContact.organizationContactId,
      domProps: {
        "value": agencyContact.organizationContactId
      }
    }, [_vm._v("\n                                          " + _vm._s(agencyContact.lastName) + " , " + _vm._s(agencyContact.firstName) + "\n                                      ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tabRequest.agencyPointOfContactId')),
      expression: "errors.has('tabRequest.agencyPointOfContactId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Agency POC is required")])])]), _vm._v(" "), (_vm.selectedAgencyContact != null) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Agency Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAgencyContact.email),
      expression: "selectedAgencyContact.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Agency Email"
    },
    domProps: {
      "value": (_vm.selectedAgencyContact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedAgencyContact, "email", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasAgencyPocOther) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Agency POC Other")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.agencyPointOfContactOther),
      expression: "fieldworkRequest.agencyPointOfContactOther"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Other POC Name"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.agencyPointOfContactOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "agencyPointOfContactOther", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Client/Proponent Project Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.clientProjectName),
      expression: "fieldworkRequest.clientProjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Client/Proponent Project Name"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.clientProjectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "clientProjectName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Reason For Fieldwork")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.reasonForFieldwork),
      expression: "fieldworkRequest.reasonForFieldwork"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Reason For Fieldwork"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.reasonForFieldwork)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "reasonForFieldwork", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Brief Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.briefDescription),
      expression: "fieldworkRequest.briefDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Brief Description"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.briefDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "briefDescription", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Fieldwork Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.workTypeList), function(workType) {
    return _c('div', {
      key: workType.workTypeId,
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.rawWorkTypeList),
        expression: "rawWorkTypeList"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'check_' + workType.workTypeId
      },
      domProps: {
        "value": workType.workTypeId,
        "checked": Array.isArray(_vm.rawWorkTypeList) ? _vm._i(_vm.rawWorkTypeList, workType.workTypeId) > -1 : (_vm.rawWorkTypeList)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.rawWorkTypeList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = workType.workTypeId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.rawWorkTypeList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.rawWorkTypeList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.rawWorkTypeList = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "for": 'check_' + workType.workTypeId
      }
    }, [_vm._v(_vm._s(workType.description))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Scope (for surveys)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.surveyScopeId),
      expression: "fieldworkRequest.surveyScopeId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "surveyScopeId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fieldworkRequest, "surveyScopeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.surveyScopeList), function(surveyScope) {
    return _c('option', {
      key: surveyScope.surveyScopeId,
      domProps: {
        "value": surveyScope.surveyScopeId
      }
    }, [_vm._v("\n                                          " + _vm._s(surveyScope.description) + "\n                                      ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('tabRequest.proposedStartDate')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Proposed Start Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "MM/dd/yyyy",
      "placeholder": "Select Date"
    },
    model: {
      value: (_vm.fieldworkRequest.proposedStartDate),
      callback: function($$v) {
        _vm.$set(_vm.fieldworkRequest, "proposedStartDate", $$v)
      },
      expression: "fieldworkRequest.proposedStartDate"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.proposedStartDate),
      expression: "fieldworkRequest.proposedStartDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "proposedStartDate",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.proposedStartDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "proposedStartDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tabRequest.proposedStartDate')),
      expression: "errors.has('tabRequest.proposedStartDate')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Proposed Start Date")])])], 1)])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled && !_vm.hasAgencyRole
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('tabRequest.proposedEndDate')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Proposed End Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "MM/dd/yyyy",
      "placeholder": "Select Date"
    },
    model: {
      value: (_vm.fieldworkRequest.proposedEndDate),
      callback: function($$v) {
        _vm.$set(_vm.fieldworkRequest, "proposedEndDate", $$v)
      },
      expression: "fieldworkRequest.proposedEndDate"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.proposedEndDate),
      expression: "fieldworkRequest.proposedEndDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "proposedEndDate",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.proposedEndDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "proposedEndDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tabRequest.proposedEndDate')),
      expression: "errors.has('tabRequest.proposedEndDate')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Proposed End Date")])])], 1)])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Crew Chief(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.crewChiefs),
      expression: "fieldworkRequest.crewChiefs"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Crew Chief(s)"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.crewChiefs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "crewChiefs", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Crew Members")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.crewMembers),
      expression: "fieldworkRequest.crewMembers"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Crew Members"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.crewMembers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "crewMembers", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.landOwnershipLegacy) ? _c('div', {
    staticClass: "form-group"
  }, [_c('landOwnership', {
    attrs: {
      "parentId": _vm.fieldworkRequestId,
      "source": "FieldworkRequest",
      "formDisabled": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.landOwnershipLegacy) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Approximate Area (in whole acres)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('table', {
    attrs: {
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "75px"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Intensive/Class III")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Extensive/Other")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Total")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Federal")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "125px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fieldworkRequest.acresFederalIntensive),
      expression: "fieldworkRequest.acresFederalIntensive",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.acresFederalIntensive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "acresFederalIntensive", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "125px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fieldworkRequest.acresFederalExtensive),
      expression: "fieldworkRequest.acresFederalExtensive",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.acresFederalExtensive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "acresFederalExtensive", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.addValues([_vm.fieldworkRequest.acresFederalIntensive, _vm.fieldworkRequest.acresFederalExtensive])))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Other Public")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fieldworkRequest.acresOtherPublicIntensive),
      expression: "fieldworkRequest.acresOtherPublicIntensive",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.acresOtherPublicIntensive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "acresOtherPublicIntensive", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fieldworkRequest.acresOtherPublicExtensive),
      expression: "fieldworkRequest.acresOtherPublicExtensive",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.acresOtherPublicExtensive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "acresOtherPublicExtensive", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.addValues([_vm.fieldworkRequest.acresOtherPublicIntensive, _vm.fieldworkRequest.acresOtherPublicExtensive])))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Private")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fieldworkRequest.acresPrivateIntensive),
      expression: "fieldworkRequest.acresPrivateIntensive",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.acresPrivateIntensive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "acresPrivateIntensive", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fieldworkRequest.acresPrivateExtensive),
      expression: "fieldworkRequest.acresPrivateExtensive",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.acresPrivateExtensive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "acresPrivateExtensive", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.addValues([_vm.fieldworkRequest.acresPrivateIntensive, _vm.fieldworkRequest.acresPrivateExtensive])))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "25px"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.addValues([_vm.fieldworkRequest.acresFederalIntensive, _vm.fieldworkRequest.acresOtherPublicIntensive, _vm.fieldworkRequest.acresPrivateIntensive])))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.addValues([_vm.fieldworkRequest.acresFederalExtensive, _vm.fieldworkRequest.acresOtherPublicExtensive, _vm.fieldworkRequest.acresPrivateExtensive])))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Field Org. Comments")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [((_vm.checkConsultantRole || _vm.checkAdminRole)) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.fieldOrganizationComments),
      expression: "fieldworkRequest.fieldOrganizationComments"
    }],
    staticClass: "form-control",
    staticStyle: {
      "color": "#555555"
    },
    attrs: {
      "disabled": !_vm.canSave,
      "placeholder": "Field Org. Comments"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.fieldOrganizationComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "fieldOrganizationComments", $event.target.value)
      }
    }
  }) : _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "color": "#555555"
    },
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.fieldworkRequest.fieldOrganizationComments) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Lead Agency Comments")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [((_vm.hasAgencyRole || _vm.checkAdminRole)) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.leadAgencyComments),
      expression: "fieldworkRequest.leadAgencyComments"
    }],
    staticClass: "form-control",
    staticStyle: {
      "color": "#555555"
    },
    attrs: {
      "disabled": !_vm.canSave,
      "placeholder": "Lead Agency Comments"
    },
    domProps: {
      "value": (_vm.fieldworkRequest.leadAgencyComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fieldworkRequest, "leadAgencyComments", $event.target.value)
      }
    }
  }) : _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "color": "#555555"
    },
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.fieldworkRequest.leadAgencyComments) + " ")])])]), _vm._v(" "), (_vm.checkAdminRole) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldworkRequest.inactive),
      expression: "fieldworkRequest.inactive"
    }],
    attrs: {
      "type": "checkbox",
      "id": "IsProjectInactive"
    },
    domProps: {
      "checked": Array.isArray(_vm.fieldworkRequest.inactive) ? _vm._i(_vm.fieldworkRequest.inactive, null) > -1 : (_vm.fieldworkRequest.inactive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.fieldworkRequest.inactive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.fieldworkRequest.inactive = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.fieldworkRequest.inactive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.fieldworkRequest, "inactive", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "IsProjectInactive"
    }
  }, [_vm._v("Set Fieldwork Request Inactive?")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.any()),
      expression: "errors.any()"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v("Required fields must be filled in prior to submit")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.serverErrorList.length > 0),
      expression: "serverErrorList.length > 0"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v("Validation issues must be corrected prior to submit")]), _vm._v(" "), _c('ul', {
    staticClass: "has-error"
  }, _vm._l((_vm.serverErrorList), function(serverError) {
    return _c('li', {
      key: serverError
    }, [_vm._v(_vm._s(serverError))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), (_vm.canSave || _vm.hasAgencyRole) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "name": "button2",
      "type": "submit"
    }
  }, [_vm._v("\n                                      " + _vm._s(_vm.fieldworkRequestId ? 'Save' : 'Create') + "\n                                  ")])]) : _vm._e()])], 1)])], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Files",
      "disabled": _vm.fieldworkRequest.fieldworkRequestId == null
    }
  }, [(_vm.project) ? _c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldworkRequestHeader', {
    attrs: {
      "fieldworkRequest": _vm.fieldworkRequest
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('media', {
    ref: "media",
    attrs: {
      "mediaTypeId": _vm.mediaTypeIdFieldworkRequest,
      "parentId": _vm.fieldworkRequestId,
      "formDisabled": _vm.formDisabled,
      "loadOnMount": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('hr'), _vm._v(" "), _c('mediaLetter', {
    ref: "mediaLetter",
    attrs: {
      "mediaTypeId": _vm.mediaTypeIdFwrLetter,
      "parentId": _vm.fieldworkRequestId,
      "loadOnMount": false
    }
  })], 1)], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Location",
      "disabled": _vm.fieldworkRequest.fieldworkRequestId == null
    }
  }, [(_vm.locationTabLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.project) ? _c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldworkRequestHeader', {
    attrs: {
      "fieldworkRequest": _vm.fieldworkRequest
    }
  }), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h5', [_vm._v("Counties")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countyToAdd),
      expression: "countyToAdd"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "initial",
      "display": "inline"
    },
    attrs: {
      "name": "countyToAdd"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countyToAdd = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a County")]), _vm._v(" "), _vm._l((_vm.countyList), function(county) {
    return _c('option', {
      key: county.countyId,
      domProps: {
        "value": county.countyId
      }
    }, [_vm._v("\n                                      " + _vm._s(county.description) + "\n                                  ")])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button2",
      "disabled": _vm.countyToAdd == ''
    },
    on: {
      "click": function($event) {
        _vm.addCounty()
      }
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _c('div', [(_vm.countyGridLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "ng-show": "countyGridSpec.tableData.length > 0"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.countyGridSpec.tableData,
      "columns": _vm.countyGridSpec.columns,
      "options": _vm.countyGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "delete",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteCountyRow(props.row.countyId)
            }
          }
        })]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h5', [_vm._v("Cadastral Location")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button3"
    },
    on: {
      "click": function($event) {
        _vm.showSectionModal()
      }
    }
  }, [_vm._v("Add Sections")]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Add Sections(s)",
      "effect": "fade/zoom",
      "value": _vm.sectionModalShow
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Add PLSS Locations")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('plssComponent', {
    ref: "plssComponent",
    attrs: {
      "showTitle": false
    },
    on: {
      "savePlss": _vm.savePlssFieldworkRequest
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeSectionModal
    }
  }, [_vm._v("Exit")])])])], 1)]), _vm._v(" "), _c('div', [(_vm.plssLocationGridLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "ng-show": "plssLocationGridSpec.tableData.length > 0"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.plssLocationGridSpec.tableData,
      "columns": _vm.plssLocationGridSpec.columns,
      "options": _vm.plssLocationGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "delete",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deletePlssLocation(props.row.fieldworkRequestPlssLocationId)
            }
          }
        })]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h5', [_vm._v("Map References")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mapReferenceToAdd),
      expression: "mapReferenceToAdd"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "initial",
      "display": "inline"
    },
    attrs: {
      "name": "mapReferenceToAdd"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mapReferenceToAdd = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a Map Reference")]), _vm._v(" "), _vm._l((_vm.mapReferenceList), function(mapReference) {
    return _c('option', {
      key: mapReference.mapReferenceId,
      domProps: {
        "value": mapReference.mapReferenceId
      }
    }, [_vm._v("\n                                      " + _vm._s(mapReference.description) + "\n                                  ")])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button2",
      "disabled": _vm.mapReferenceToAdd == ''
    },
    on: {
      "click": function($event) {
        _vm.addMapReference()
      }
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _c('div', [(_vm.mapReferenceGridLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "ng-show": "mapReferenceGridSpec.tableData.length > 0"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.mapReferenceGridSpec.tableData,
      "columns": _vm.mapReferenceGridSpec.columns,
      "options": _vm.mapReferenceGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "delete",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteMapReferenceRow(props.row.mapReferenceId)
            }
          }
        })]) : _vm._e()]
      }
    }])
  })], 1)], 1)])], 1), _vm._v(" "), (!_vm.isRestrictedRole) ? _c('tab', {
    attrs: {
      "header": "Map",
      "disabled": _vm.fieldworkRequest.fieldworkRequestId == null
    }
  }, [(_vm.project) ? _c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldworkRequestHeader', {
    attrs: {
      "fieldworkRequest": _vm.fieldworkRequest
    }
  }), _vm._v(" "), _c('mapx', {
    ref: "mapx",
    attrs: {
      "mediaTypeId": _vm.mediaTypeIdFieldworkRequest,
      "parentId": _vm.fieldworkRequestId,
      "loadOnMount": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Workflow",
      "disabled": _vm.fieldworkRequest.fieldworkRequestId == null
    }
  }, [(_vm.project) ? _c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldworkRequestHeader', {
    attrs: {
      "fieldworkRequest": _vm.fieldworkRequest
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('workflow', {
    ref: "workflow",
    attrs: {
      "fieldworkRequestErrors": _vm.errors,
      "workflowId": _vm.fieldworkRequestWorkflowId,
      "parentId": _vm.fieldworkRequestId
    },
    on: {
      "workflowOnBeforeSubmit": _vm.fieldworkRequestValidation,
      "workflowOnSubmitSuccess": _vm.workflowOnSubmitSuccess
    }
  })], 1), _vm._v(" "), (_vm.checkShpoRole) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('quickLetter', {
    attrs: {
      "projectId": _vm.fieldworkRequest.projectId,
      "fieldWorkRequestId": _vm.fieldworkRequest.fieldworkRequestId,
      "mediaTypeId": _vm.mediaTypeIdFwrLetter,
      "parentId": _vm.fieldworkRequestId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.fieldworkRequest.fieldworkRequestId) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "fwrReport"
    },
    on: {
      "click": _vm.genFwrReport
    }
  }, [_vm._v("Generate Report")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDebug),
      expression: "isDebug"
    }],
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('h4', [_vm._v("rawWorkTypeList: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.rawWorkTypeList))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Validation errors: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.errors))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("fieldworkRequest: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.fieldworkRequest))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("selectedOrganizationContact: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.selectedOrganizationContact))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("selectedAgencyContact: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.selectedAgencyContact))])])])], 1) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Fieldwork Request")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("****** Debug ******")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-853b1f32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/FieldworkRequest.vue
// module id = 971
// module chunks = 1